<template lang="">
    <div class="main-container">
        <img src="@/assets/logo.svg"/>
        <p style="margin-top:56px;margin-bottom:56px;font-size:16px;color:black;">กรุณาเข้าใช้งาน TheLivingOS ผ่านมือถือหรือแท็บเล็ตของคุณ</p>

        <div class="qr-section">
            <div class="img-section">
                <img :src="getImgUrl()" alt="">
            </div>
            <div class="appstore-text-section">
                <div class="text">
                    <p style="font-size: 20px;font-weight: 700;line-height: 32px;color:black;">TheLivingOS</p>
                    <p style="font-size: 16px;font-weight: 400;line-height: 26px;color:#8F97A6;">แอปอันดับ 1 ที่ลูกบ้านและนิติฯ เลือก</p>
                </div>
                <div class="appstore-section">
                    <a href="https://apps.apple.com/th/app/the-livingos/id1458591396">
                        <img src="@/assets/Apple.svg" alt="">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.livingos.android&hl=th&gl=US&pli=1">
                        <img src="@/assets/Google.svg" alt="">
                    </a>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
function getImgUrl() {
    return require('../assets/'+process.env.VUE_APP_URL+'.png')
}
</script>
<style lang="scss" scoped>
    .main-container{
        display: flex;
        height: 100vh;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .qr-section{
        width: 496px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px;
        border: solid 1px #EBEDF0;
        border-radius: 8px;
        .img-section{
            display: flex;
            img{
                width: 122px;
                height: 122px;
            }
        }
        .appstore-text-section{
            height: 100%;
            display: flex;
            flex:1;
            margin-left: 33px;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            
            .text{
                text-align: left;
            }
            .appstore-section{
                display: flex;
                a{
                    height: 48px;
                }
                img{
                    width: 135px;
                    height: 48px;
                }
            }
        }
        
    }
    p{
        margin: 0;
    }
</style>

